export default __webpack_public_path__ + "static/media/brdcst_on.432956c6.svg";